import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Member } from '../../api/member/member.model';
import { Product } from '../../api/tenant/product.model';
import { TenantManagerService } from '../../api/tenant/tenant-manager.service';
import { Router } from '@angular/router';

@Component({
	selector: 'mycampapp-member-list-dialog',
	templateUrl: './member-list-dialog.component.html',
	styleUrl: './member-list-dialog.component.less'
})
export class MemberListDialogComponent
{
	@Input() visible = false;
	@Input() members: Member[] = [];
	@Output() visibleChange = new EventEmitter<boolean>(); // Add this for two-way binding

	sortField = 'LastName';  // initial sort field
	sortOrder = 1;  // 1 for ascending, -1 for descending
	expandedRowKeys: { [key: string]: boolean } = {};
	membersLabel = 'Users';
	childrenLabel = 'Children';

	// Columns for the p-table
	cols = [
		{ field: 'FirstName', header: 'First Name' },
		{ field: 'LastName', header: 'Last Name' },
		{ field: 'PhoneNumber', header: 'Phone' },
		{ field: 'Email', header: 'Email' }
	];

	constructor(private tenantManager: TenantManagerService) {}

	ngOnInit()
	{
		// Sort members initially by LastName, FirstName
		this.sortMembers();
		this.setLabels();
	}

	sortMembers()
	{
		this.members.sort((a, b) =>
		{
			const compareLastName = (a.LastName || '').localeCompare(b.LastName || '');
			if (compareLastName !== 0) return compareLastName;
			return (a.FirstName || '').localeCompare(b.FirstName || '');
		});
	}

	onSort(event: any)
	{
		this.sortField = event.field;
		this.sortOrder = event.order;
	}

	onHide()
	{
		this.visible = false;
		this.visibleChange.emit(false); // Emit the change
	}

	hasChildren(member: Member): boolean
	{
		return member.Children && member.Children.length > 0;
	}

	toggleRow(member: Member)
	{
		this.expandedRowKeys[member.Id] = !this.expandedRowKeys[member.Id];
	}

	private setLabels(): void
	{
		this.tenantManager.currentProduct.subscribe((product: Product) =>
		{
			this.membersLabel = (product.getFeatureValue('Member') || 'Member') + 's';
			this.childrenLabel = product.OrganizationTypeName === 'Camps' ? 'Campers' : 'Children';
		});
	}
}
